<picture [ngClass]="pictureClassNames">
	<source
		*ngFor="let source of sortedSources"
		[srcset]="source.src"
		[media]="'(max-width: ' + source.maxWidth + ')'"
	/>
	<img [src]="src" [alt]="alt" [ngClass]="imageClassNames" />
</picture>
